import { styled, TextareaAutosize } from 'components/base';
import {
  grey,
  common,
  normalText,
  primary,
  secondary,
  text,
} from 'assets/colors';

export const textFieldLabelStyles = {
  '& .MuiInputLabel-root': {
    transform: 'translate(14px, 14px) scale(0.75) !important',
    top: -5,
    left: 0,
    transformOrigin: 'top left',
    color: text.secondary,
    fontSize: '18px !important',
  },
  '& .MuiInputLabel-shrink': {
    transform: 'translate(14px, -2px) scale(0.75) !important',
    color: text.secondary,
    fontSize: '14px !important',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: primary.border,
  },
  '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: `${secondary.main} !important`,
  },
  '& .Mui-focused': {
    color: primary.main,
  },
  '&::placeholder': {
    fontSize: '20px', // Adjust the font size as needed
  },
  '& .css-1kaq46u-MuiFormLabel-root-MuiInputLabel-root.Mui-focused': {
    color: 'inherit !important',
  },

  // style for disabled input
  '& .Mui-disabled': {
    backgroundColor: ' #f2f2f2',
    borderColor: '#98a5b9',
  },
};

export const LineItemStyledTextarea = styled(TextareaAutosize)(({ theme }) => ({
  boxSizing: 'border-box',
  width: '100%',
  padding: '8px 8px',
  marginTop: 8.5,
  ...theme.typography.body2,
  color: normalText.main,
  background: common.white,
  borderRadius: 4,
  border: '1px solid #dcdcdc',
  resize: 'none',

  '&::-webkit-scrollbar': {
    width: 7,
    height: 7,
  },
  '&::-webkit-scrollbar-track': {
    background: grey.g100,
  },
  '&::-webkit-scrollbar-thumb': {
    background: grey.g400,
    borderRadius: 4,
  },

  '&::placeholder': {
    color: `${grey.g200} !important`,
  },

  '&:hover': {
    borderColor: secondary.main,
  },

  '&:focus': {
    borderColor: secondary.main,
  },

  '&:focus-visible': {
    outline: 0,
  },

  '&:disabled': {
    background: grey.g200,
    color: grey.g600,
    cursor: 'not-allowed',
  },
}));
